// WARNING!
// This file is generated automatically by 'makolab-routes' npm script, please DO NOT edit it!
// If you want to add new component to routes-map, create a new file 
// with it's name matching: 'COMPONENT_TYPE.container.js' in 'src/components' directory,
// where 'COMPONENT_TYPE' is any kebab-case name

import Loadable from 'react-loadable';

export default (Loading = () => null) => ({
  confirmPage: {
    Component: Loadable({
      loader: () => import('./components/confirm-page/confirm-page.container.js'),
      loading: Loading
    })
  },
  notFound: {
    Component: Loadable({
      loader: () => import('./components/not-found/not-found.container.js'),
      loading: Loading
    })
  },
  onlineFormPage: {
    Component: Loadable({
      loader: () => import('./components/online-form-page/online-form-page.container.js'),
      loading: Loading
    })
  },
  starterPage: {
    Component: Loadable({
      loader: () => import('./components/starter-page/starter-page.container.js'),
      loading: Loading
    })
  },
  thankYouPage: {
    Component: Loadable({
      loader: () => import('./components/thank-you-page/thank-you-page.container.js'),
      loading: Loading
    })
  }
});



// WEBPACK FOOTER //
// ./src/routes-map.js